
$(document).ready(function(){

  $("#video-template--16764437430505__c8e90f26-4109-4c6c-ad57-f1b037c539da > div.plyr.plyr--full-ui.plyr--video.plyr--html5.plyr--paused.plyr--stopped.plyr--pip-supported.plyr--fullscreen-enabled > button").click();

  

// document.addEventListener('DOMContentLoaded', function() {
// document.querySelector(".plyr__control").click();
//       }, false);


  
 

  
  // $( '.promo-banner__content' ).html('<p>25 % OFF SITE WIDE NOV 25 - 27 Use Code BF-22 Free Domestic Shipping over $150</p>');
  // setInterval(function(){ 

  //   $( '.promo-banner__content' ).delay(2000).fadeOut(1000,function(){
  //     $(this).html("<p>** Backorders may take 4-6 weeks ** We cannot guarantee Holiday delivery</p>");
  //   }).fadeIn(2000).delay(3000);
  //   $( '.promo-banner__content' ).delay(2000).fadeOut(1000,function(){
  //     $(this).html('<p>25 % OFF SITE WIDE NOV 25 - 27 Use Code BF-22 Free Domestic Shipping over $150</p>'); 
  //   }).fadeIn(2000).delay(3000);

  // }, 2000);


  var btn = $('#bttbutton');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});


});


